import { atomWithToggle } from './utils';

export const isDebuggerModalOpenAtom = atomWithToggle(false);
export const isDebuggerEnabledAtom = atomWithToggle(false);
